import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PaginateReqEntity, PaginateRespEntity } from '../../../interface';
import { ALPHABET_NUMBER_SPACE_PATTERN_DOT_ALLOW } from '../../../utils/pattern';
import { removeSpaceOnFirstCharacter, IsFormValid, checkValidInputOnKeyDown, displayDateFormat, scrollTop, checkActionAuthorization } from '../../../service/shared.service';
import { IsNullOrEmptyArray, IsStringNullEmptyOrUndefined } from '../../../utils/null-check';
import { searchInputPlaceholder, toastOptObj } from "../../../utils/constants";
import { toast } from 'react-toastify';
import { RadioButton } from 'primereact/radiobutton';
import { AxiosResponse } from 'axios';
import { APIResponseEntity } from '../../../interface/api-responce';
import { APIToCreateBOMUOM, APIToDeleteBOMUOM, APIToGetBOMUOM, APIToUpdateBOMUOM } from '../../../service/api-service';
import Loader from '../../../components/loader';
import { DataTable, DataTableSortEvent } from 'primereact/datatable';
import { Column } from 'primereact/column';
import DeleteConfirmationDialog from '../../../components/delete-confirmation';
import PrimePaginator from '../../../components/prime-paginator';
import { PaginatorPageChangeEvent } from 'primereact/paginator';
import { BOMUOMDetailsEntity } from '../../../interface/settings/bom-uom';
declare var $: any;

function BOMUOM() {

    const navigate = useNavigate();

    const [uom, setUom] = useState<string>('');

    const [status, setStatus] = useState<boolean>(true);

    const [formErrors, setFormErrors] = useState<{ uom: string }>({
        uom: 'Please enter BOM UOM',
    });

    const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [filterReq, setFilterReq] = useState<PaginateReqEntity>({
        pageSize: 10,
        pageNumber: 0,
        searchText: '',
        sortColumn: 'createdAt',
        sortOrder: '-1'
    });

    const [searchKeyword, setSearchKeyword] = useState<string>('');

    const [bomUomList, setBomUomList] = useState<BOMUOMDetailsEntity[] | []>([]);

    const [totalPageCount, setTotalPageCount] = useState<number>(0);

    const [isDeleteRecordId, setIsDeleteRecordId] = useState<string>('');

    const [isUpdateRecordId, setIsUpdateRecordId] = useState<string>('');

    const [isEdit, setIsEdit] = useState<boolean>(false);

    const Status = [
        { name: 'Active', code: true },
        { name: 'Inactive', code: false },
    ];

    // Authorizations with fallback to CS Master permissions
    const canCreate = checkActionAuthorization('create', 'BOM Mapping UOM') ||
        checkActionAuthorization('create', 'CS Master');

    const canUpdate = checkActionAuthorization('update', 'BOM Mapping UOM') ||
        checkActionAuthorization('update', 'CS Master');

    const canDelete = checkActionAuthorization('delete', 'BOM Mapping UOM') ||
        checkActionAuthorization('delete', 'CS Master');


    useEffect(() => { return () => { toast.dismiss(); }; }, []);

    useEffect(() => {
        const fetchData = async (): Promise<void> => {
            await fetchBOMUOMList();
        };
        fetchData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterReq]);

    useEffect(() => {
        $("#id_of_bom_uom_searchbox").keyup((event: any) => {
            const searchText: string = IsStringNullEmptyOrUndefined(event.target.value) ? '' : event.target.value;

            if (event.keyCode === 13 &&
                (
                    (IsStringNullEmptyOrUndefined(searchText))
                    ||
                    (!IsStringNullEmptyOrUndefined(searchText) && searchText.length >= 2)
                )
            ) {
                setFilterReq({ ...filterReq, searchText, pageNumber: 0 });
            }
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchBOMUOMList = async (): Promise<void> => {
        setIsLoading(true);
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToGetBOMUOM(filterReq);
            setBomUomList([]);
            setTotalPageCount(0);

            if (resp) {
                if (resp && resp.data && resp.status === 200) {
                    const axiosResp: APIResponseEntity = resp.data;

                    if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                        const paginateResp: PaginateRespEntity = axiosResp.data;
                        setBomUomList(paginateResp.data || []);
                        setTotalPageCount(paginateResp.totalCount || 0);
                    }
                } else {
                    toast.error(resp.data.message, { ...toastOptObj });
                }
            }
        } catch (error) {
            console.error('Error fetching BOM UOM list:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleChange = (value: string) => {
        const isValid: boolean = IsStringNullEmptyOrUndefined(value) || ALPHABET_NUMBER_SPACE_PATTERN_DOT_ALLOW.test(value);
        setFormErrors({
            uom: IsStringNullEmptyOrUndefined(value)
                ? 'Please enter BOM UOM' :
                (!isValid ? 'Please enter valid BOM UOM' :
                    (value.trim().length >= 1 ? '' : 'Minimum 1 character is required'))
        });

        setUom(value);
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        setIsFormSubmitted(true);
        const isValid = IsFormValid(formErrors);
        if (isValid && !IsStringNullEmptyOrUndefined(uom.trim())) {
            setIsFormSubmitted(false);
            try {
                setIsLoading(true);
                const reqObj = { name: uom.trim(), uom: uom.trim(), isActive: status };
                const resp: AxiosResponse<APIResponseEntity> = isEdit
                    ? await APIToUpdateBOMUOM(isUpdateRecordId, reqObj)
                    : await APIToCreateBOMUOM(reqObj);
                if (resp) {
                    if (resp.data && (resp.status === 200 || resp.status === 201)) {
                        const axiosResp: APIResponseEntity = resp.data;
                        if (axiosResp && axiosResp.status &&
                            (axiosResp.statusCode === 200 || axiosResp.statusCode === 201)) {
                            toast.success(axiosResp.message || `BOM UOM ${isEdit ? 'updated' : 'created'} successfully`, { ...toastOptObj });
                            resetForm();
                            setFilterReq({ ...filterReq, pageNumber: 0 });
                        } else {
                            toast.error(axiosResp.message, { ...toastOptObj });
                        }
                    } else {
                        toast.error(resp.data.message, { ...toastOptObj });
                    }
                }
            } catch (error: any) {
                console.error('Error submitting BOM UOM:', error);
                const msg = error?.response?.data?.message || 'Something went wrong';
                toast.error(msg, { ...toastOptObj });
            } finally {
                setIsLoading(false);
            }
        }
    };

    const deleteBOMUOMRecord = async (value: boolean) => {
        if (!value) { return; }
        setIsLoading(true);
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToDeleteBOMUOM(isDeleteRecordId);
            if (resp) {
                if (resp.data && resp.status === 200) {
                    const axiosResp: APIResponseEntity = resp.data;
                    if (axiosResp && axiosResp.status && axiosResp.statusCode === 200) {
                        toast.success(axiosResp.message || 'BOM UOM deleted successfully', { ...toastOptObj });
                        resetForm();
                        setFilterReq({ ...filterReq, pageNumber: 0 });
                    } else {
                        toast.error(axiosResp.message, { ...toastOptObj });
                    }
                } else {
                    toast.error(resp.data.message, { ...toastOptObj });
                }
            }
        } catch (error: any) {
            console.error('Error deleting BOM UOM:', error);
            const msg = error?.response?.data?.message || 'Unable to delete BOM UOM';
            toast.error(msg, { ...toastOptObj });
        } finally {
            setIsLoading(false);
        }
    };

    const updateBOMUOMRecord = (rowData: BOMUOMDetailsEntity) => {
        const rowUom = rowData.name || '';
        setUom(rowUom);
        setStatus(rowData.isActive ?? true);
        setFormErrors({
            uom: !IsStringNullEmptyOrUndefined(rowUom) ? '' : 'Please enter BOM UOM',
        });
        setIsUpdateRecordId(rowData.id);
        setIsEdit(true);
    };

    const dateCreatedBodyTemplate = (rowData: BOMUOMDetailsEntity) => {
        return displayDateFormat(rowData.createdAt as string);
    };

    const dateUpdatedBodyTemplate = (rowData: BOMUOMDetailsEntity) => {
        return displayDateFormat(rowData.updatedAt as string);
    };

    const uomBodyTemplate = (rowData: BOMUOMDetailsEntity) => {
        return rowData.name || '-';
    };

    const actionIconTemplate = (rowData: BOMUOMDetailsEntity) => {
        return (
            <ul className="tableIcon cursor-pointer action-icon-template-w">
                {canUpdate &&
                    <li data-toggle="tooltip" title="Edit">
                        <img src="assets/images/edit-icon.svg" alt="Edit" onClick={() => { updateBOMUOMRecord(rowData); scrollTop(); }} />
                    </li>}
                {canDelete &&
                    <li data-toggle="tooltip" title="Delete" onClick={() => setIsDeleteRecordId(rowData.id)}>
                        <DeleteConfirmationDialog
                            isAccepted={deleteBOMUOMRecord}
                        />
                    </li>}
            </ul>
        );
    };

    const onPageChange = (event: PaginatorPageChangeEvent) => {
        setFilterReq({ ...filterReq, pageSize: event.rows, pageNumber: event.page });
    };

    const onSort = (event: DataTableSortEvent) => {
        setFilterReq({ ...filterReq, sortColumn: event.sortField, sortOrder: String(event.sortOrder), pageNumber: 0 });
    };

    const statusBodyTemplate = (rowData: BOMUOMDetailsEntity) => {
        return <span className={`badge badge-${rowData.isActive === true ? "success" : "danger"}`}> {rowData.isActive ? "Active" : "Inactive"}</span>;
    };

    const resetForm = (): void => {
        setIsUpdateRecordId('');
        setUom('');
        setStatus(true);
        setFormErrors({ uom: 'Please enter BOM UOM' });
        setIsEdit(false);
    };


    return (
        <>
            <Loader isLoading={isLoading} />

            <div className="content-wrapper">
                <div className='col-12'>
                    <div className='row'>
                        <div className="col-lg-4 col-md-4 mb-md-0 mb-3">
                            <div className="card card-rounded">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className="col-lg-12 col-md-12 col-12">
                                            <h4 className="card-title">BOM UOM</h4>
                                        </div>
                                    </div>
                                    {canCreate ?
                                        <form onSubmit={handleSubmit}>

                                            <div className="form-group mb-3">
                                                <label>BOM UOM <sup className='mandatory'>*</sup></label>
                                                <input type="text" name='uom' className="form-control form-control-lg"
                                                    placeholder="Enter UOM (e.g. PCS, MTR, SET)"
                                                    onChange={(e) => handleChange(e.target.value)}
                                                    maxLength={50} value={uom}
                                                    onKeyDown={(event: any) => {
                                                        checkValidInputOnKeyDown(event, ALPHABET_NUMBER_SPACE_PATTERN_DOT_ALLOW);
                                                        removeSpaceOnFirstCharacter(event);
                                                    }}
                                                />
                                                {
                                                    isFormSubmitted &&
                                                    <small className="text-danger font-weight-500">
                                                        {formErrors.uom}
                                                    </small>
                                                }
                                            </div>

                                            <div className="form-group">
                                                <label>STATUS</label>
                                                <div className='d-flex mb-2'>
                                                    {Status.map((option: any) => (
                                                        <div key={String(option.code)} className="d-flex align-items-center mb-2">
                                                            <RadioButton
                                                                inputId={`bom-uom-status-${String(option.code)}`}
                                                                name="status"
                                                                className='me-2'
                                                                value={option.code}
                                                                onChange={(e) => setStatus(e.value)}
                                                                checked={status === option.code}
                                                            />
                                                            <label htmlFor={`bom-uom-status-${String(option.code)}`} className='me-5 cursor-pointer'>{option.name}</label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className='col-12'>
                                                <button type="submit" className="btn btn-block btn-primary btn-md font-weight-medium m-0 me-2"
                                                >{isEdit ? 'Update' : 'Save'}</button>

                                                <button
                                                    type="button"
                                                    className="btn btn-cancel text-dark m-0"
                                                    onClick={() => IsStringNullEmptyOrUndefined(isUpdateRecordId) ? navigate('/settings') : resetForm()}>
                                                    {IsStringNullEmptyOrUndefined(isUpdateRecordId) ? 'Cancel' : 'Clear'}
                                                </button>
                                            </div>
                                        </form> : <div className="alert alert-danger" role="alert">
                                            You don't have permission to create BOM UOM
                                        </div>}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-8">
                            <div className="card card-rounded">
                                <div className='card-body'>
                                    <div className="col-md-8 mb-3 ms-sm-auto">
                                        <div className="input-group search-grp">
                                            <img src="assets/images/search.svg"
                                                alt="search" className="input-group-text searchIptGrpTxt" />

                                            <input type="text" className='form-control form-control-lg searchInput'
                                                placeholder={searchInputPlaceholder}
                                                value={searchKeyword} id="id_of_bom_uom_searchbox"
                                                onChange={(e) => setSearchKeyword(e.target.value)}
                                            />
                                            {!IsStringNullEmptyOrUndefined(searchKeyword) && (
                                                <button
                                                    className="btn btn-cancel text-dark search-button-clear"
                                                    type="button"
                                                    onClick={() => {
                                                        setSearchKeyword('');
                                                        setFilterReq({ ...filterReq, searchText: '', pageNumber: 0 });
                                                    }}
                                                >
                                                    Clear
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <DataTable value={bomUomList}
                                            sortField={filterReq.sortColumn}
                                            sortOrder={filterReq.sortOrder ? (parseInt(filterReq.sortOrder) as 1 | -1) : -1}
                                            onSort={onSort}
                                            emptyMessage="No BOM UOM found"
                                        >
                                            <Column field="name" body={uomBodyTemplate} header="BOM UOM"></Column>
                                            <Column body={statusBodyTemplate} header="Status" ></Column>
                                            <Column field="createdAt" header="Created Date" body={dateCreatedBodyTemplate} sortable></Column>
                                            <Column field="updatedAt" header="Last Updated Date" body={dateUpdatedBodyTemplate} sortable></Column>
                                            {(canUpdate || canDelete) &&
                                                <Column header="Action" body={actionIconTemplate}></Column>
                                            }
                                        </DataTable>
                                    </div>

                                    {
                                        !IsNullOrEmptyArray(bomUomList) && <PrimePaginator
                                            onPageChange={onPageChange}
                                            pageNumber={filterReq.pageNumber}
                                            pageSize={filterReq.pageSize}
                                            totalRecords={totalPageCount}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BOMUOM;
